import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2UsersSaveAssetsDetailResponse {
  message: string;
  id: string;
};

// 请求接口
interface AgentV2UsersSaveAssetsDetailRequest {
  agentId: string;
  userId: string;
  pushSetting: {
    type: number;
    pushFrequencyDay: number;
    pushCount: number;
    pushTime: number;
  }[];
}


export class AgentV2UsersSaveAssetsDetailData {
  id: string | number;
}

const transformAndValidateAgent = (
  response: AgentV2UsersSaveAssetsDetailResponse
): AgentV2UsersSaveAssetsDetailData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2UsersSaveAssetsDetailData);
  } catch (error) {
    console.error("Agent V2 Users Save Assets Detail data validation failed:", error.message);
    throw error;
  }
};

/** 保存用户推送详情*/
export const agentV2UsersSaveAssetsDetail = async (params: AgentV2UsersSaveAssetsDetailRequest): Promise<AgentV2UsersSaveAssetsDetailData> => {
  const response = await api.post<AgentV2UsersSaveAssetsDetailResponse>('/agent-v2/users/save-assets-detail', {
    agent_id: params.agentId,
    user_id: params.userId,
    push_setting: params.pushSetting.map(item => ({
      type: item.type,
      push_frequency_day: item.pushFrequencyDay,
      push_count: item.pushCount,
      push_time: item.pushTime,
    })),
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
